export default __webpack_public_path__ + "static/media/news23111401.2a241332.jpg";